<template>
  <div>
    <MoneyBankOfficeManager v-if="roleAdmin === 'office-manager'|| 'accountant' || 'super-accountant' " />
    <MoneyBankSuperManager v-if="roleAdmin === 'super-manager' " />
  </div>
</template>

<script>
import MoneyBankOfficeManager from './money-bank/MoneyBankOfficeManager.vue'
import MoneyBankSuperManager from './money-bank/MoneyBankSuperManager.vue'

export default {
  components: {
    MoneyBankOfficeManager,
    MoneyBankSuperManager,
  },
  data() {
    return {
      roleAdmin: localStorage.getItem('accessRole'),
    }
  },

}
</script>
